<template>
    <form-container header-text="Passfoto hochladen" :width="450" :action="action"
                    :valid-actions="['foto']" :button-ok="changed?'Speichern':''"
                    header-icon="mdi-card-account-details" @save="save">
        <div class="px-6" v-if="actionObject && $route.query.action==='foto'">
            <p>Mitglied: <span class="font-weight-bold primary--text">{{actionObject.spieler.vorname}}
            {{actionObject.spieler.nachname}}</span>
            (Pass-Nr. <span class="font-weight-bold">{{actionObject.spieler.passNr}}</span>)
            </p>
            <image-upload-crop :image="newValue" collection="passfotos" @imageDeleted="deleteImage"
                               @selected="getImage" @getCropped="getCropped">
            </image-upload-crop>
            <error-msg v-if="error" :error="error"></error-msg>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../../components/form/formContainer";
    import ImageUploadCrop from "../../../components/images/imageUploadCrop";
    import {CloudStorageHandler} from "../../../services/storage/cloudStorageHandler";
    import DATABASE_HANDLER from "../../../services/database/databaseHandler";
    import ErrorMsg from "../../../components/elements/errorMsg";
    import {firestore} from "../../../services/db";
    import {PassNrService} from "@/services/data/paesse/passNrService";
    import PRINT_PAESSE_UPDATE_SPIELER from "@/services/print/printPaesseUpdateSpieler";
    //import {db} from "../../../services/db";

    export default {
        components: {
            ErrorMsg,
            ImageUploadCrop,
            FormContainer},
        name: "spieler-foto",
        props: ['action', 'actionObject'],
        data: () => ({
            newValue: {
                url: '',
                urlMin: '',
                crop: '',
            },
            isChange: false,
            error: '',
            changed: false,
        }),
        methods: {
            async save(){
                this.error = '';
                if ( !this.newValue.urlMin && this.actionObject.local.spieler.url ) {
                    await this.deleteImageFromServer();
                    window.history.back();
                    return;
                }
                if ( !this.newValue.urlMin && !this.actionObject.local.spieler.url ) {
                    this.error = "Bitte klicke vor dem Speichern auf 'Foto wählen' um ein Foto auszuwählen."; return;
                }
                await this.uploadImage();
                // close immediately
                window.history.back();
            },
            async deleteImageFromServer(){
                const cloudStorageHandler = new CloudStorageHandler();
                await cloudStorageHandler.deleteFile('/passfotos/' + this.actionObject.local.spieler.id + '.jpeg');
                let spieler = this.actionObject.local.spieler;
                spieler.local = { documentUpdates: {url: firestore.FieldValue.delete()}};
                await DATABASE_HANDLER.updateWithTransaction('spieler_edit', false, spieler);
            },
            async uploadImage(){
            // path of the image file in the firebase cloud storage
                const imageName = 'passfotos/' +
                                  this.actionObject.local.spieler.id + '.jpeg'; // +
                                  //this.actionObject.local.spieler.vorname + '_' +
                                  //this.actionObject.local.spieler.nachname + '.jpeg';
            // define source path
                const sourcePath = this.$store.state.config.storage.passfotos;
            // upload through cloud storage handler
                const cloudStorageHandler = new CloudStorageHandler();
                let url = await cloudStorageHandler.addFile(imageName, this.newValue.urlMin);
            // save downloadUrl without path (only image file name + token)
                if (url) {
                    url = url.replace(sourcePath, '');
                    url = url.split('?')[1];
                    //url = url.replace(this.duel.id + '%2F', '');
                    console.log ("URL", url);
                    let spieler = this.actionObject.local.spieler;
                    if ( this.actionObject.local.spieler.search.passStatus === 'beantragt' ) {
                        const passNrService = new PassNrService(
                            Object.keys(spieler.search.lastAktiv)[0], // ACHTUNG: lvId-Ermittlung geht nur hier so!!!
                            this.actionObject.local.spieler.geschlecht)
                        let passNr = await passNrService.getPassNr();
                        passNr = passNr.data
                        const membership = spieler.memberships[0]
                        membership.passNr = passNr
                        spieler.local  = { documentUpdates: {
                            url: url,
                            memberships: [membership],
                            ['search.passNumbers']: {[passNr]: true},
                            ['search.passStatus']: '',
                            waitingForPassPrint: true,
                            waitingForPlayerPassPrint: true,
                        }};
                    } else {
                        spieler.local = { documentUpdates:
                            PRINT_PAESSE_UPDATE_SPIELER.getUpdateObjectForFotoChange(spieler, url)
                        };
                    }
                    await DATABASE_HANDLER.updateWithTransaction('spieler_edit', false, spieler);
                }
            // return
                if ( this.actionObject.local.spieler.search.passStatus !== 'beantragt') {
                    this.actionObject.actionType = 'edit';
                    this.actionObject.changes = [{field: 'Foto', valueOld: '', valueNew: 'neues Foto hochgeladen'}];
                    this.actionObject.setTimeStamp();
                    this.actionObject.setEditPending();
                    await this.actionObject.saveNew('document');
                }
            },
            getImage(image){
                this.newValue.url = image;
                this.changed = true;
            },
            getCropped(image, coordinates) {
                console.log ("getCropped");
                if ( JSON.stringify(coordinates) !== this.newValue.crop ) {
                    this.newValue.urlMin = image;
                    if ( coordinates.width !== 120 || coordinates.left !== 15 || coordinates.top !== 20 ) {
                        this.changed = true;
                    }
                    console.log("CROP: ", coordinates);
                    this.newValue.crop = JSON.stringify(coordinates);
                }
            },
            deleteImage(){
                this.changed = true;
                this.newValue = {
                    url: '',
                    urlMin: '',
                    crop: '',
                }
            }
        },
        watch: {
            actionObject: {
                handler(){
                    this.newValue = {
                        url: '',
                        urlMin: '',
                        crop: '',
                    };
                    //this.isChange = false;
                    this.changed = false;
                    this.error = '';
                    //this.isChange = this.actionObject.local.spieler.url !== '';
                    this.newValue.url = this.actionObject.local.spieler.url ?
                                        this.actionObject.local.spieler.id + ".jpeg?" +
                                        this.actionObject.local.spieler.url :
                                        '';
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>